import { BidiModule } from '@angular/cdk/bidi';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { PlatformModule } from '@angular/cdk/platform';
import { PortalModule } from '@angular/cdk/portal';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { NgModule } from '@angular/core';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { MatTableModule } from '@angular/material/table';


@NgModule({
    imports: [
        MatButtonModule,
        MatButtonToggleModule,
        MatCardModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatMenuModule,
        MatSidenavModule,
        MatToolbarModule,
        MatProgressBarModule,
        MatSelectModule,
        MatProgressSpinnerModule,
        MatCheckboxModule,
        MatRadioModule,
        MatDialogModule,
        MatExpansionModule,
        MatAutocompleteModule,
        MatDatepickerModule,
        MatMomentDateModule,
        MatTabsModule,
        MatSlideToggleModule,
        MatTooltipModule,
        MatChipsModule,
        MatGridListModule,
        MatSliderModule,
        MatPaginatorModule,
        MatTreeModule,
        MatStepperModule,
        ScrollingModule,
        PortalModule,
        BidiModule,
        ClipboardModule,
        MatBadgeModule,
        PlatformModule,
        MatTableModule
    ],
    exports: [
        MatButtonModule,
        MatButtonToggleModule,
        MatCardModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatMenuModule,
        MatSidenavModule,
        MatToolbarModule,
        MatProgressBarModule,
        MatSelectModule,
        MatProgressSpinnerModule,
        MatCheckboxModule,
        MatRadioModule,
        MatDialogModule,
        MatExpansionModule,
        MatAutocompleteModule,
        MatDatepickerModule,
        MatMomentDateModule,
        MatTabsModule,
        MatSlideToggleModule,
        MatTooltipModule,
        MatChipsModule,
        MatGridListModule,
        MatSliderModule,
        MatPaginatorModule,
        MatTreeModule,
        MatStepperModule,
        ScrollingModule,
        PortalModule,
        BidiModule,
        ClipboardModule,
        MatBadgeModule,
        PlatformModule,
        MatTableModule
    ]
})
export class MaterialModule { }
